export const COLOR = {
  corporatePrimaryColor: '#00A23F',
  gray: '#555',
  lightGray: '#ddd',
  superLightGray: '#f5f5f5',
  alert: '#ffbaba',
  success: '#e9f8e6',
  errorMessage: '#ad2a1a',
  lightBlue: 'rgba(60, 134, 201, 0.3)',
  lightRed: 'rgba(215, 95, 72, 0.3)',
};
